module.exports = __webpack_public_path__ + "img/ha.d910c223.png";